module.exports = __webpack_public_path__ + "img/border-top-left.8f851cfc.svg";